import s from "./styles.module.css";
import {FormControl, MenuItem, Select} from "@mui/material";
import React, {useEffect, useState} from "react";
import api from "../../../api/api";
import classNames from "classnames";

const FigureTable = ({
                         el,
                         i,
                         figure,
                         figureData,
                         setOpenDialog,
                         setSportsmanName,
                         setApplicationFigureId,
                         isNotStarted,
                         isDisqualified
                     }) => {

    const [select, setSelect] = useState('');

    useEffect(() => {
        if ((isNotStarted === 0 || isNotStarted === null) && (isDisqualified === 0 || isDisqualified === null)) {
            setSelect('---');
        } else if (isNotStarted === 1) {
            setSelect('DNS');
        } else {
            setSelect('DSQ');
        }
    }, [isNotStarted, isDisqualified]);

    const handleChange = async (event) => {
        setSelect(event.target.value);
        let body = {
            competition_application_discipline_id: el?.application_figure_id,
            is_not_started: null,
            is_disqualified: null
        }
        if (event.target.value === '---') {
            body.is_not_started = 0;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DNS') {
            body.is_not_started = 1;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DSQ') {
            body.is_not_started = 0;
            body.is_disqualified = 1;
        }

        if (body.is_not_started !== null && body.is_disqualified !== null) {
            const res = await api().patch('/figure/change-not-started-or-disqualified', body);
            console.log(res);
        }
    };

    return (<div id={figureData?.commands?.application_figure?.length - 1 === i ? 'figureItem' : ''}
                 className={s.header} key={i}>
        <div className={classNames(s.item, (select === 'DNS' || select === 'DSQ') && s.disable_command)} style={{
            minWidth: '55px',
            fontSize: '20px',
            fontWeight: 508,
        }}
             onDoubleClick={() => {
                 setOpenDialog(true)
                 setSportsmanName(el?.user_name)
                 setApplicationFigureId(el?.application_figure_id)
             }}
        >{el.draw}</div>
        <div className={s.item} style={{minWidth: '150px'}}>
            <p className={s.item_title}>{el.user_name}</p>
            {i === 0 && <p className={s.header_title}>ФИО</p>}
        </div>
        <div className={s.item} style={{minWidth: '70px'}}>
            <p className={s.item_title}>{el.user_year}</p>
            {i === 0 && <p className={s.header_title}>г.р.</p>}
        </div>
        <div className={s.item} style={{minWidth: '72px'}}>
            <p className={s.item_title}>{el.user_category}</p>
            {i === 0 && <p className={s.header_title}>Раз</p>}
        </div>
        <div className={s.item} style={{minWidth: '100px'}}>
            <p className={s.item_title}>{el.user_command}</p>
            {i === 0 && <p className={s.header_title}>Команда</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.f1_result !== 'null' ? el.f1_result : null}</p>
            {i === 0 && <p className={s.header_title}>{figure?.commands?.figures['f1_result']}</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.f2_result !== 'null' ? el.f2_result : null}</p>
            {i === 0 && <p className={s.header_title}>{figure?.commands?.figures['f2_result']}</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.f3_result !== 'null' ? el.f3_result : null}</p>
            {i === 0 && <p className={s.header_title}>{figure?.commands?.figures['f3_result']}</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.f4_result !== 'null' ? el.f4_result : null}</p>
            {i === 0 && <p className={s.header_title}>{figure?.commands?.figures['f4_result']}</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.total_result !== 'null' ? el.total_result : null}</p>
            {i === 0 && <p className={s.header_title}>Резуль</p>}
        </div>
        <div className={s.item} style={{minWidth: '82px'}}>
            <p className={s.item_title}>{el.poins_behind !== 'null' ? el.poins_behind : null}</p>
            {i === 0 && <p className={s.header_title}>Отст.</p>}
        </div>
        <div className={s.item} style={{minWidth: '74px'}}>
            <p className={s.item_title}>{el.rank !== 'null' ? el.rank : null}</p>
            {i === 0 && <p className={s.header_title}>Rank</p>}
        </div>

        <div className={s.item_status}>
            {i === 0 && <p className={s.header_title}>Status</p>}
            <FormControl sx={{minWidth: 86}}>
                <Select
                    labelId="select-label"
                    value={select}
                    onChange={(e) => handleChange(e)}
                    inputProps={{'aria-label': 'Выбор опции'}}
                    sx={{
                        height: '35px',
                        width: '86px',
                        backgroundColor: '#fff',
                        fontSize: '13px'
                    }}
                >
                    <MenuItem value="---" sx={{fontSize: '13px'}}>---</MenuItem>
                    <MenuItem value="DNS" sx={{fontSize: '13px'}}>DNS</MenuItem>
                    <MenuItem value="DSQ" sx={{fontSize: '13px'}}>DSQ</MenuItem>
                </Select>
            </FormControl>
        </div>
    </div>)
}

export default FigureTable;